<template>
  <div class="produtos js">
    <!-- loading效果 暂时不用 -->
    <!-- <div v-if="loading" class="loading-overlay">
      <div class="wave">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
      </div>
    </div> -->
    <div class="produtos-cont">
      <div class="produtos-section-swiper">
        <swiper :options="produtosSwiperOptions" v-if="swiperTopList">
          <swiper-slide v-for="(item, index) in swiperTopList" :key="index" class="slide">
              <img :src="item.img" alt="" class="produtos-swiper-img">
              <div class="produtos-image-slideshow"></div>
              <div class="produtos-swiper-title">
                  <div class="title1" data-animate data-animate-order="1">
                      {{ item.content_title }}
                  </div>
                  <div data-animate data-animate-order="2" v-if="item.content_content" class="title2">
                      {{ item.content_content }}
                  </div>
              </div>
          </swiper-slide>
        </swiper>
      </div>
      <div class="produtos-section">
        <div class="produtos-section-cont1-title">
          <!-- <div class="produtos-section-cont1-title-text animated fadeIn">
            <div class="produtos-section-cont1-title-text-cont">
              <div class="produtos-section-cont1-title-text-cont-margin">
                <h2 data-animate data-animate-order="1">{{ rnd_strength?.value[0]?.title }}</h2>
              </div>
            </div>
          </div> -->
        </div>
      </div>
      <div class="produtos-section">
        <div class="produtos-cont1 p1-bk">
          <div class="produtos-cont1-cont" v-if="rnd_strength && rnd_strength?.value">
            <div class="produtos-cont1-cont-cont produtos-cont1-cont-left kb-enabled in-viewport">
              <div>
                <div class="cont1-img">
                  <div class="responsive-image-wrapper">
                    <img loading="lazy" class="theme-img js" style=" object-fit:cover;object-position:50.0% 50.0%!important;" alt="" width="2048" height="2048" :srcset="`${rnd_strength?.value[0]?.img} 550w,
                    ${rnd_strength?.value[0]?.img} 750w,
                    ${rnd_strength?.value[0]?.img} 1100w,
                    ${rnd_strength?.value[0]?.img} 1445w,
                    ${rnd_strength?.value[0]?.img} 1680w,
                    ${rnd_strength?.value[0]?.img} 2048w`" 
                    sizes="100vw" 
                    :src="rnd_strength?.value[0]?.img">
                  </div>
                </div>
              </div>
            </div>
            <div class="produtos-cont1-cont-cont produtos-cont1-cont-right">
              <div>
                <div class="produtos-cont1-cont-right-inner animated fadeIn">
                  <div data-animate data-animate-order="3">
                    <h2>{{ rnd_strength?.value[0]?.content_title }}</h2>
                  </div>
                  <div class="produtos-cont1-cont-right-inner-rte" data-animate data-animate-order="4" v-html="rnd_strength?.value[0]?.content_content">
                  </div>
                  <!-- <p>At KOMO, 
                      <strong>research and innovation are the foundation</strong> of our scalp care science. Our R&amp;D team has built one of the industry’s strongest innovation pipelines, holding 50 invention patents, 42 licensed patents, and 10 software copyrights, along with 30 clinical certificates in hair loss prevention.
                    </p>
                    <p>
                      We 
                      <strong>combine global natural resources with advanced biotechnology</strong>
                      , sourcing over 50 proprietary herbal ingredients through international partnerships. Built on 20 years of expertise, every formulation is supported by three major databases: <strong>Scalp Database, Raw Material Database, and Formula Database</strong>.
                    </p> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="produtos-section">
        <div class="produtos-cont1 animated fadeIn">
          <div class="produtos-cont2-cont" v-if="factory && factory?.value">
            <div class="produtos-cont2-cont-background kb-enabled in-viewport">
              <div class="produtos-cont2-cont-background-div">
                <img loading="eager" class="theme-img  js" style=" object-fit:cover;object-position:50.0% 50.0%!important;" alt="" width="1676" height="1117" :srcset="`${factory?.value[0].img} 550w,
                ${factory?.value[0].img} 750w,
                ${factory?.value[0].img} 1100w,
                ${factory?.value[0].img} 1445w,
                ${factory?.value[0].img} 1676w`" 
                sizes="100vw" 
                :src="factory?.value[0].img">
              </div>
            </div>
            <div class="produtos-cont2-cont-font">
              <div class="produtos-cont2-cont-font-text">
                <h2 data-animate data-animate-order="3">{{factory?.value[0].title}}</h2>
                <div class="produtos-cont2-cont-font-text-font" data-animate data-animate-order="4" v-html="factory?.value[0].content">
                </div>
                <!-- <h5>KOMO operates self-owned, GMP-certified production facilities that ensure world-class quality and consistency. Equipped with large-scale automation and flexible small-batch capabilities, our factories are designed to meet the diverse needs of scalp and hair care product categories. Through personalized intelligent production and an end-to-end digital supply chain system (MES, WMS, ERP), we guarantee efficiency, transparency, and precision at every stage. The facilities are ISO 22716 certified and supported by full data traceability, ensuring the highest standards of safety, accountability, and reliability in every product we deliver.</h5>-->
              </div> 
            </div>
          </div>
        </div>
      </div>
      <div class="produtos-section">
        <div class="produtos-section-cont1-title">
          <div class="produtos-section-cont1-title-text animated fadeIn">
            <div class="produtos-section-cont1-title-text-cont">
              <div class="produtos-section-cont1-title-text-cont-margin" v-if="signature_raw_materials && signature_raw_materials?.value">
                <h2 data-animate data-animate-order="1">{{ signature_raw_materials?.value[0]?.title }}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="produtos-section jsss">
        <div class="produtos-section-swiper-Two animated fadeIn">
          <div class="swiper-cont" data-animate data-animate-order="1">
            <swiper ref="materialSwiper" :options="materialSwiperOptions" v-if="signature_raw_materials && signature_raw_materials?.value">
              <swiper-slide v-for="(item, index) in signature_raw_materials?.value[0]?.content" :key="index" class="material-item">
                <img :src="item.img" alt="" class="material-image">
                <div class="material-info">
                  <h3>{{ item.title }}</h3>
                </div>
              </swiper-slide>
            </swiper>
            <div class="swiper-button swiper-button-prev"></div>
            <div class="swiper-button swiper-button-next"></div>
          </div>
        </div>
      </div>
      <div class="produtos-section">
        <div class="produtos-section-cont1-title">
          <div class="produtos-section-cont1-title-text animated fadeIn">
            <div class="produtos-section-cont1-title-text-cont" v-if="patents_and_rewards && patents_and_rewards?.value">
              <div class="produtos-section-cont1-title-text-cont-margin">
                <h2 data-animate data-animate-order="1">{{ patents_and_rewards?.value[0]?.title }}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="produtos-section">
        <div class="produtos-section-swiper-Two">
          <div class="swiper-cont produtos-cont1">
            <div class="produtos-cont1-cont" v-if="patents_and_rewards && patents_and_rewards?.value">
              <div class="produtos-cont1-cont-left kb-enabled in-viewport">
                <div>
                  <div class="responsive-image-wrapper responsive-image-wrapper-s">
                    <img loading="lazy" class="theme-img js"alt="" width="1406" height="684" :srcset="`${patents_and_rewards?.value[0]?.img} 550w,
                    ${patents_and_rewards?.value[0]?.img} 750w,
                    ${patents_and_rewards?.value[0]?.img} 1100w,
                    ${patents_and_rewards?.value[0]?.img} 1406w`" 
                    sizes="100vw" 
                    :src="patents_and_rewards?.value[0]?.img">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import { getBannerListing,getDataList } from '@/api/komo'
export default {
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      bannerList: [],
      technologyList: [],
      swiperTopList: {},  //根据code分配每个模块数据
      rnd_strength:{},  //根据code分配每个模块数据
      patents_and_rewards: {},  //根据code分配每个模块数据
      factory: {},  //根据code分配每个模块数据
      signature_raw_materials: {},  //根据code分配每个模块数据
      
      showNavigation: false, // 控制导航按钮显示
      // produtosSwiperList: [
      //   {
      //     img: require('@/assets/assetsNew/home/technology1.png'),
      //     title1: 'Wash',
      //     title2: 'KEMO Product Series',
      //   },
      //   {
      //     img: require('@/assets/assetsNew/home/technology2.png'),
      //     title1: 'Cleanse',
      //   },
      //   {
      //     img: require('@/assets/assetsNew/home/technology3.png'),
      //     title1: 'Care',
      //   },
      //   {
      //     img: require('@/assets/assetsNew/home/technology4.png'),
      //     title1: 'Nourish',
      //   },
      //   {
      //     img: require('@/assets/assetsNew/home/technology5.png'),
      //     title1: 'Body',
      //   },
      //   {
      //     img: require('@/assets/assetsNew/home/technology6.png'),
      //     title1: 'Treat',
      //   },
      //   {
      //     img: require('@/assets/assetsNew/home/technology7.png'),
      //     title1: 'Style',
      //   },
      // ],
      produtosSwiperOptions: {
        initialSlide: 0,
        autoplay: {
            delay: 5000, // 自动切换时间间隔
            disableOnInteraction: false // 用户操作后是否停止自动切换，默认为true
        },
        loop: true,
        effect: 'fade', // 添加渐变效果
        fadeEffect: {
          crossFade: true // 交叉淡入淡出
        },
        speed: 1000, // 添加过渡速度控制
        on: {
          slideChangeTransitionStart: () => {
            // 当幻灯片开始切换时，移除所有动画类
            setTimeout(() => {
              const swiperContainer = document.querySelector('.produtos-section-swiper');
              if (swiperContainer) {
                const animateElements = swiperContainer.querySelectorAll('[data-animate]');
                animateElements.forEach(element => {
                  element.classList.remove('animate-trigger');
                });
              }
            }, 100);
          },
          slideChangeTransitionEnd: () => {
            // 当幻灯片切换完成时，重新触发动画
            setTimeout(() => {
              this.initAnimations();
            }, 100);
          }
        }
      },
      // 新增的材料轮播数据
      // materialSwiperList: [
      //   {
      //     img: require('@/assets/assetsNew/produtos/produtos-3.webp'),
      //     title: 'Proidra Horse Chestnut',
      //   },
      //   {
      //     img: require('@/assets/assetsNew/produtos/produtos-4.webp'),
      //     title: 'Myrothamnus Flabellifolia',
      //   },
      //   {
      //     img: require('@/assets/assetsNew/produtos/produtos-5.webp'),
      //     title: 'Argania Spinosa',
      //   },
      //   {
      //     img: require('@/assets/assetsNew/produtos/produtos-6.webp'),
      //     title: 'Vitellaria',
      //   }
      // ],
      // 材料轮播配置
      materialSwiperOptions: {
        initialSlide: 0,
        // autoplay: {
        //     delay: 5000, // 自动切换时间间隔
        //     disableOnInteraction: false // 用户操作后是否停止自动切换，默认为true
        // },
        loop: false, // 无限循环
        loopAdditionalSlides: 0, // 循环时额外复制的slide数量
        slideToClickedSlide: false, // 点击slide直接切换
        slidesPerView: 1.1, // 一次显示3个 slides
        spaceBetween: 15, // 设置 slides 之间的间距
        breakpoints: {
          765: {
            slidesPerView: 3.5,
            spaceBetween: 10,
          },
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
      },
      loading: true, // 添加这一行
    }
  },
  async created () {
    await this.initData();
  },
  mounted() {
    
  },
  methods: {
    async initData () {
      // loading效果 暂时不用
      // this.loading = true; // 开始加载时显示loading
    
      try {
        // const result = await getBannerListing('4');
        // this.bannerList = result.data.list;
        // 第一个轮播数据-------------------------------------
        const technologySwiperData = await getDataList('1');
        technologySwiperData?.data?.list.forEach((item) => {
          if (item.code == 'home_komo_technology') {
            this.swiperTopList = item.value[0].content;
          }
        })
        // 第一个轮播数据-------------------------------------
        const technologyDatalist = await getDataList(localStorage.getItem('pageId'));
        this.technologyList = technologyDatalist?.data?.list || [];
        this.technologyList.forEach((item) => {
          if (item.code == "rnd_strength") {
            this.rnd_strength = item;
          } else if (item.code == "patents_and_rewards") {
            this.patents_and_rewards = item;
          } else if (item.code == "factory") {
            this.factory = item;
          } else if (item.code == "signature_raw_materials") {
            this.signature_raw_materials = item;
          }
        })
      } catch (error) {
        console.error('数据加载失败:', error);
      } finally {
        this.loading = false; // 加载完成后隐藏loading
        
        this.$nextTick(() => {
          this.initAnimations()
          this.initIntersectionObserver();
        });
      }
    },
    initAnimations () {
      const currentSlide = document.querySelector('.swiper-slide-active');
      if (currentSlide) { 
        // 获取所有带 data-animate 属性的元素
        const animateElements = currentSlide.querySelectorAll('[data-animate]');
        
        animateElements.forEach(element => {
          const order = element.getAttribute('data-animate-order') || 0;
          // 添加延时，按顺序播放动画
          setTimeout(() => {
            element.classList.add('animate-trigger');
          }, order);
        });
      }
    },
    initIntersectionObserver () {
      // 获取produtos-sectio所有需要观察的元素（包括图片和文字）
      const produtosSections = this.$el.querySelectorAll('.produtos-section');
      let allImageElements = [];
      let allTextElements = [];
      produtosSections.forEach(section => {
        // 获取当前 section 中的图片元素和文字元素
        const imageElements = section.querySelectorAll('.kb-enabled');
        const textElements = section.querySelectorAll('[data-animate]');
        
        allImageElements = [...allImageElements, ...imageElements];
        allTextElements = [...allTextElements, ...textElements];
      });
      const allElements = [...allImageElements, ...allTextElements];
      if (allElements.length > 0) { 
        // 移除所有元素的初始动画类
        allImageElements.forEach(element => {
          element.classList.remove('in-viewport');
        });
        allTextElements.forEach(element => {
          element.classList.remove('animate-trigger');
        });

        // 创建交叉观察器
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            const element = entry.target;
            if (entry.isIntersecting) {
              // 元素进入视口
              // 如果是图片元素
              if (element.classList.contains('kb-enabled')) {
                element.classList.add('in-viewport');
              } 
              // 如果是文字元素
              else if (element.hasAttribute('data-animate')) {
                // 添加动画触发类
                element.classList.add('animate-trigger');
              }
            } else {
              // 元素离开视口（支持重复动画）
              if (element.classList.contains('kb-enabled')) {
                element.classList.remove('in-viewport');
              } else if (element.hasAttribute('data-animate')) {
                element.classList.remove('animate-trigger');
              }
            }
          });
        }, {
          threshold: 0.1, // 当10%的元素可见时触发
          rootMargin: '0px 0px -50px 0px' // 提前50px触发
        });
        // 开始观察所有元素
        allElements.forEach(element => {
          observer.observe(element);
        });
      }
    },
    // 鼠标进入时显示导航按钮
    onSwiperMouseEnter() {
      this.showNavigation = true;
      // 暂停自动播放
      if (this.$refs.materialSwiper && this.$refs.materialSwiper.$swiper) {
        this.$refs.materialSwiper.$swiper.autoplay.stop();
      }
    },
    // 鼠标离开时隐藏导航按钮
    onSwiperMouseLeave() {
      this.showNavigation = false;
      // 恢复自动播放
      if (this.$refs.materialSwiper && this.$refs.materialSwiper.$swiper) {
        this.$refs.materialSwiper.$swiper.autoplay.start();
      }
    }
  }
}
</script>
<style scoped lang="scss">
.produtos{
  padding: var(--nav-max-height) 0 0;
  display: block;
  .produtos-cont{
    display: block;
    padding: 0;
    .produtos-section-swiper{
      width: 100%;
      .produtos-swiper-img {
        width: 100%;
        height: 55vw;
      }
      .produtos-image-slideshow{
        background:linear-gradient(180deg,
                rgba(0, 0, 0, 0.2) 50%,
                rgba(0, 0, 0, 0.6));
        z-index: 0;
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
      }
      .produtos-swiper-title {
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        padding: 60px;

        .title1 {
            color: #ffffff;
            font-size: 60px;
            font-family: var(--header-font-stack);
        }

        .title2 {
            color: #ffffff;
            font-size: 24px;
            font-family: var(--body-font-stack);
        }
      }
      
    }
    .produtos-section-swiper-Two{
        padding-top: 0;
        padding-bottom: 60px * .75;
        .swiper-cont{
          max-width: 86%;
          margin: 0 auto;
          position: relative;
          // 材料轮播项样式
          .material-item {
            // background: #fff;
            // border-radius: 8px;
            overflow: hidden;
            // box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
            transition: transform 0.3s ease, box-shadow 0.3s ease;
            position: relative;
            &:hover {
              // transform: translateY(-5px);
              // box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
            }
            
            .material-image {
              overflow: hidden;
              object-fit: cover;
              object-position: 50.0% 50.0% !important;
              aspect-ratio: auto;
              max-width: 100%;
              border: 0 none;
              width: 100%;
              height: auto;
              
              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                transition: transform 0.3s ease;
              }
            }
            
            .material-info {
              padding: 20px;
              position: absolute;
              bottom: 0;
              left: 0;
              h3 {
                font-size: var(--h3-size);
                margin: 0 0 0px;
                color: var(--font-color);
              }
              
              p {
                font-size: 14px;
                color: #666;
                margin: 0;
                line-height: 1.5;
              }
            }
          }
          .swiper-button{
            width: 40px;
            height: 40px;
            background: #422b20;
            /* 可点击时的背景色 */
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: background .25s;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            opacity: 0;
            /* 默认隐藏 */
            visibility: hidden;
            /* 同时把鼠标事件也藏起来 */
            transition: opacity .3s ease, visibility .3s ease, transform .4s ease;
            z-index: 10;
            overflow: hidden;
            &::after {
              font-size: 16px;
              color: #fff;
              /* 箭头白色 */
            }
          }
          .swiper-button-prev{
            left: 10px;
            transform: translateY(-50%) translateX(-60px);
            &:hover::before{
              background-image: linear-gradient(90deg, transparent, hsla(0, 0%, 100%, .25), transparent);
              content: "";
              height: 100%;
              left: -200%;
              position: absolute;
              top: 0;
              transform: skew(-20deg);
              width: 200%;
              animation: shineAgainLeft .75s cubic-bezier(.01, .56, 1, 1);
            }
          }
          .swiper-button-next{
            right: 10px;
            transform: translateY(-50%) translateX(60px);
            &:hover::before{
              background-image: linear-gradient(90deg, transparent, hsla(0, 0%, 100%, .25), transparent);
              content: "";
              height: 100%;
              right: -200%;
              position: absolute;
              top: 0;
              transform: skew(-20deg);
              width: 200%;
              animation: shineAgainRight .75s cubic-bezier(.01, .56, 1, 1);
            }
          }
          .swiper-button-disabled{
            background: #422b2050;
          }
          &:hover .swiper-button{
            opacity: 1;
            visibility: visible;
          }
          &:hover .swiper-button-prev{
            transform: translateY(-20%) translateX(30px);
          }
          &:hover .swiper-button-next{
            transform: translateY(-20%) translateX(-30px);
          }
        }
    }
    .produtos-section{
      width: 100%;
      .produtos-section-cont1-title-text-cont{
        position: relative;
        display: inline-block;
        width: 100%;
        vertical-align: top;
        .produtos-section-cont1-title-text-cont-margin{
          max-width: 920px;
          margin:0 auto;
          text-align: center;
          h2{
            font-size: 30px;
            color: var(--font-color);
          }
        }
      }
      .p1-bk{
        background: #e8e2d9;
      }
      .produtos-cont1{
        padding-top: 0;
        padding-bottom: 0;
        margin-top: 0;
        margin-bottom: 0;
        .produtos-cont1-cont{
          width: 100%;
          vertical-align: top;
          position: relative;
          display: flex;
          flex-direction: column;
        }
        .produtos-cont1-cont-left{
          display: flex;
          flex-direction: column;
          justify-content: center;
          margin: 0;
          padding: 0;
          box-sizing: border-box;
          float: left;
          min-height: 1px;
          vertical-align: top;
          width: 100%;
          .responsive-image-wrapper {
            display: flex;
            align-items: center;
            justify-content: center;
            img{
              display: block;
              border: 0 none;
              width: 100%;
              height: auto;
              max-width: 100%;
              object-fit: cover;
              object-position: 50.0% 50.0% !important;
              aspect-ratio: auto 2048 / 2048;
            }
          }
          .responsive-image-wrapper-s{
            display: flex;
            align-items: center;
            justify-content: center;
            img{
              display: block;
              width: 100%;
              height: 100%;
              max-width: 100%;
              aspect-ratio: auto 1406 / 684;
              object-fit: cover;
              object-position: 50.0% 50.0% !important;
            }
          }
        }
        .produtos-cont1-cont-right{
          padding: 32px 20px;
          .produtos-cont1-cont-right-inner div{
            text-align: center;
            h2{
              font-size: var(--h2-size);
              color: var(--font-color);
            }
          }
          .produtos-cont1-cont-right-inner-rte{
            margin-bottom: 0;
            p{
              margin-bottom: 0;
              font-size: var(--base-font-size);
              font-family: var(--body-font-stack);
              font-weight: var(--body-font-weight);
              font-style: var(--body-font-style);
              -webkit-font-smoothing: antialiased;
              -webkit-text-size-adjust: 100%;
              color: var(--font-color);
            }
            p:first-child {
              margin-top: 0;
            }
          }
        }
        .produtos-cont2-cont{
          display: grid;
          grid-template: auto / auto;
          min-height: auto;
          .produtos-cont2-cont-background{
            position: relative;
            grid-column: 1 / 2;
            grid-row: 1 / 2;
            &::after{
              content: "";
              display: block;
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              background-color: color-mix(in srgb, rgba(36 36 36 / 1.0), transparent 73%);
            }
            img{
              display: block;
              border: 0 none;
              width: 100%;
              height: auto;
              max-width: 100%;
              object-fit: cover;
              object-position: 50.0% 50.0% !important;
              aspect-ratio: auto 1676 / 1117;
            }
          }
          .produtos-cont2-cont-font{
            align-items: center;
            justify-content: center;
            z-index: 1;
            display: flex;
            padding: 15px;
            grid-column: 1 / 2;
            grid-row: 1 / 2;
            .produtos-cont2-cont-font-text{
              background: rgba(0 0 0 / 0.0);
              color: #ffffff;
              text-align: center;
              display: block;
              font-size: var(--base-font-size);
              font-family: var(--body-font-stack);
              font-weight: var(--body-font-weight);
              font-style: var(--body-font-style);
              -webkit-font-smoothing: antialiased;
              -webkit-text-size-adjust: 100%;
              h2{
                padding-bottom: 25px;
                font-size: 28px;
                line-height: 1.2;
                letter-spacing:-0.01em;
              }
              .produtos-cont2-cont-font-text-font{
                padding-bottom: 7px;
                font-size: var(--h5-size);
                margin-bottom: 0;
              }
            }
          }
        }
      }
      &:last-child{
        padding-bottom: 60px;
      }
    }
  }
  .kb-enabled{
    overflow: hidden;
  }
}
.produtos-section-cont1-title{
  padding-top: 30px;
  padding-bottom: 12px;
}
// loading效果 暂时不用
// .loading-overlay {
//   position: fixed;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
//   background-color: rgba(255, 255, 255, 0.9);
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   z-index: 9999;
// }
// .wave {
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   height: 100vh;
// }
// .wave span {
//   display: inline-block;
//   width: 10px;
//   height: 20px;
//   margin: 0 3px;
//   background-color: #422b20;
//   animation: wave 1.2s infinite ease-in-out;
// }
// .wave span:nth-child(1) {
//   animation-delay: 0s;
// }
// .wave span:nth-child(2) {
//   animation-delay: 0.1s;
// }
// .wave span:nth-child(3) {
//   animation-delay: 0.2s;
// }
// .wave span:nth-child(4) {
//   animation-delay: 0.3s;
// }
// .wave span:nth-child(5) {
//   animation-delay: 0.4s;
// }
// @keyframes wave {
//   0%, 40%, 100% {
//     transform: scaleY(0.4);
//   }
//   20% {
//     transform: scaleY(1);
//   }
// }
@media screen and (min-width: 768px) {
  .produtos-section-cont1-title{
    padding-top: 60px;
    padding-bottom: 40px;
  }
  .produtos .produtos-cont .produtos-section .produtos-cont1 .produtos-cont1-cont{
    display: flex;
    flex-direction: row;
  }
  .produtos .produtos-cont .produtos-section .produtos-cont1 .produtos-cont1-cont-cont{
    width: 50%;
  }
  /* 图片动画 - 从大变小 */
  .kb-enabled > * {
    transform: translate3d(.25rem, .12rem, .25rem) scale(1.06);
    transform-origin: left center;
    transition: transform 2s ease;
  }
  
  /* 添加延迟，确保动画触发 */
  .kb-enabled.in-viewport > * {
    animation: scaleDown 2s ease forwards;
    transform-origin: left center;
  }
  .produtos-cont1-cont-right{
    display: flex;
    flex-direction: column;
    justify-content: center;
    background: #e8e2d9;
  }
  .produtos .produtos-cont .produtos-section .produtos-cont1 .produtos-cont1-cont-right .produtos-cont1-cont-right-inner{
    padding: 0;
    width: max-content;
    max-width: 75%;
    margin: 0 auto;
    color: var(--font-color);
  }
  .produtos .produtos-cont .produtos-section .produtos-cont1 .produtos-cont1-cont-right .produtos-cont1-cont-right-inner-rte p{
    text-align: center;
  }
  .produtos .produtos-cont .produtos-section .produtos-cont1 .produtos-cont2-cont .produtos-cont2-cont-font{
    align-items: center;
    justify-content: center;
    padding: 60px;
  }
  .produtos .produtos-cont .produtos-section .produtos-cont1 .produtos-cont2-cont .produtos-cont2-cont-font .produtos-cont2-cont-font-text{
    text-align: center;
    max-width: 85%;
  }
  .produtos .produtos-cont .produtos-section .produtos-cont1 .produtos-cont2-cont .produtos-cont2-cont-font .produtos-cont2-cont-font-text h2{
    font-size: 30px;
  }
  .produtos .produtos-cont .produtos-section-swiper-Two{
    padding-top: 0;
    padding-bottom: 0;
  }
}
@media (prefers-reduced-motion: reduce) {
  .kb-enabled > * {
    transition: none !important;
  }
  .swiper-button-prev,
  .swiper-button-next {
    display: none !important;
  }
}
@media (max-width: 1115px){
  .produtos{
    padding: var(--nav-1115-height) 0 0;
  }
}
@media (max-width: 990px){
  .produtos{
    padding: var(--nav-990-height) 0 0;
  }
}
@media screen and (max-width: 767px) {
  .produtos .produtos-cont .produtos-section-swiper-Two .swiper-cont .swiper-button{
    display: none;
  }
  .produtos .produtos-cont .produtos-section .produtos-cont1 .produtos-cont2-cont .produtos-cont2-cont-background .produtos-cont2-cont-background-div{
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .produtos .produtos-cont .produtos-section .produtos-cont1 .produtos-cont2-cont .produtos-cont2-cont-background img{
    max-width: 100%;
    height: 100%;
  }
  .produtos .produtos-cont .produtos-section .produtos-cont1 .produtos-cont2-cont .produtos-cont2-cont-font .produtos-cont2-cont-font-text h2{
    margin: 0;
    padding-bottom: 8px;
    padding-top: 10px;
  }
}
</style>